import React from 'react';
import styled from 'styled-components';
import {isMobileOnly} from 'react-device-detect';

const SpanNcInfoPriceBlock = styled.span`
    float: left;
    display: block;
    margin-top: ${isMobileOnly?"2rem":"9px"};
    /*margin-top: 9px;*/
    float: left;
    color: #333;
    font-size: 14px
`;
const SpanNcInfoNumberBlock = styled.span`
    font-family: Montserrat,sans-serif;
`;

const SpanNcInfoPrice = ({ minValue, maxValue }) => {

    if (minValue === undefined || maxValue === undefined
        || minValue === null || maxValue === null) {

        return <SpanNcInfoPriceBlock />
    }

    return (
        <SpanNcInfoPriceBlock>
            <SpanNcInfoNumberBlock>{Number(minValue.toFixed(1)).toLocaleString()}</SpanNcInfoNumberBlock>
            &nbsp;원&nbsp;~
            <SpanNcInfoNumberBlock>{Number(maxValue.toFixed(1)).toLocaleString()}</SpanNcInfoNumberBlock>
            &nbsp;원
        </SpanNcInfoPriceBlock>
    );
};

export default SpanNcInfoPrice;
